import { useContext } from 'react';

import { ContextLogInfo } from '@/context/LogInfo';
import type { SharedSessionResponse } from '@/types/share-session';

export default function useLogGenius(): SharedSessionResponse | undefined {
  return useContext(ContextLogInfo);
}
